import { useSelector } from "react-redux";
import "./GlCurrency.scss";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import newRequest from "../../../utils/newRequest.js";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { FiSearch } from "react-icons/fi";
import { motion } from "framer-motion";
import moment from "moment";
import { useEffect, useState } from "react";
import { FaSave } from "react-icons/fa";
import { IoClose } from "react-icons/io5";
import { GridLoader, ScaleLoader } from "react-spinners";
import { useTranslation } from "react-i18next";
import { MdAdd, MdArrowBackIos, MdClose, MdDelete } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";

const GlCurrency = () => {
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const { t } = useTranslation();
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");
  const [isProcessing, setIsProcessing] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(true);
  const [savingTitle, setSavingTitle] = useState("Save");
  const [currencyPairs, setCurrencyPairs] = useState([]);
  const [selectedCurrencyPair, setSelectedCurrencyPair] = useState({});
  const [currencyPairRates, setCurrencyPairRates] = useState([]);
  const [selectedCurrencyPairRate, setSelectedCurrencyPairRate] = useState({});
  const [searchTerm, setSearchTerm] = useState("");
  const [currencyAction, setCurrencyAction] = useState("");

  const [isNewRateDialogOpened, setIsNewRateDialogOpened] = useState(false);
  const [newRateFmDate, setNewRateFmDate] = useState(null);
  const [newRateToDate, setNewRateToDate] = useState(null);
  const [newRate, setNewRate] = useState(null);

  const navigate = useNavigate();
  const location = useLocation();
  const showBack = location.state?.showBack || "N";
  const favMenu = location.state?.favMenu || "N";
  const menuDocid = location.state?.menuDocid || undefined;

  const handleFmDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setNewRateFmDate(formattedGlDate);
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleToDateChange = async (e) => {
    try {
      if (e.target.value) {
        const formattedGlDate = moment(e.target.value).format("YYYY-MM-DD");
        setNewRateToDate(formattedGlDate);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleAddRate = async () => {
    try {
      if (!newRateFmDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter from date!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!newRateToDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter to date!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      // TODO
      // Check Overlapping Dates

      if (!newRate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter rate!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      const formattedFmDate = new Date(
        moment(newRateFmDate).format("YYYY-MM-DD")
      );
      formattedFmDate.setHours(0, 0, 0, 0);
      const formattedToDate = new Date(
        moment(newRateToDate).format("YYYY-MM-DD")
      );
      formattedToDate.setHours(0, 0, 0, 0);

      // Compare the dates
      if (formattedFmDate > formattedToDate) {
        console.log("from is greater than to date");
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(
          `From date ${moment(newRateFmDate).format(
            "DD-MMM-YYYY"
          )} cannot be greater than to date ${moment(newRateToDate).format(
            "DD-MMM-YYYY"
          )}!`
        );
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);
      const res = await newRequest.post(
        "/glCurrencyRate/add/",
        {
          rate_cur_code_fm: selectedCurrencyPair?.baseCurrency,
          rate_cur_code_to: selectedCurrencyPair?.quoteCurrency,
          rate_date_fm: newRateFmDate,
          rate_date_to: newRateToDate,
          rate: newRate
        }
      );

      if (res.status === 200) {
        fetchCurrencyPairRates(
          selectedCurrencyPair?.baseCurrency,
          selectedCurrencyPair?.quoteCurrency
        );
        setNewRateFmDate(null);
        setNewRateToDate(null);
        setNewRate(null);
        setIsNewRateDialogOpened(false);
        setIsProcessing(false);
        showToast("Rate Added!", "success");
      } else {
        showToast(res.data, "error");
      }

    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const handleAddCurrency = async () => {
    try {
      if (!newCurrencyName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter name!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!newCurrencyCode) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter code!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsProcessing(true);
      const res = await newRequest.post(
        "/glCurrency/add/",
        {
          cur_org_code: currentUser.usr_org_code,
          cur_code: newCurrencyCode,
          cur_name: newCurrencyName,
          cur_symbol: newCurrencySymbol || newCurrencyCode,
          cur_enabled: "Y",
          userCode: currentUser.usr_id,
        }
      );
      fetchCurrencyPairs();
      setNewCurrencyCode(null);
      setNewCurrencyName(null);
      setNewCurrencySymbol(null);

      setIsNewRateDialogOpened(false);

      showToast("Currency Added!", "success");
    } catch (error) {
      console.log(error);
    } finally {
      setIsProcessing(false);
    }
  };

  const [newCurrencyCode, setNewCurrencyCode] = useState(null);
  const [newCurrencyName, setNewCurrencyName] = useState(null);
  const [newCurrencySymbol, setNewCurrencySymbol] = useState(null);

  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    action_invoked: "",
  });


  const fetchCurrencyPairs = async () => {
    try {
      setIsLoading(true);
      const res = await newRequest.post(
        "/glCurrency/pairs",
        {
          cur_org_code: currentUser.usr_org_code,
          base_currency: currentUser.currency_code_xx,
        }
      );
      setCurrencyPairs(res.data);
      setSelectedCurrencyPair(res.data[0]);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const fetchCurrencyPairRates = async (fromCurrency, toCurrency) => {
    try {
      // console.log("Firing fetchCalendarPeriods....");
      const res = await newRequest.post(
        "/glCurrencyRate/findAll",
        {
          cur_org_code: currentUser.usr_org_code,
          rate_cur_code_fm: fromCurrency,
          rate_cur_code_to: toCurrency,
        }
      );

      setCurrencyPairRates(res.data);
      setSelectedCurrencyPairRate(res.data[0]);
      setIsProcessing(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    fetchCurrencyPairs();
  }, []);

  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [currentPage, setCurrentPage] = useState(0);
  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };
  const slicedCurrencyPairRates = currencyPairRates.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 12));
    setCurrentPage(0);
  };


  const filteredCurrencyPairs = currencyPairs.filter(
    (item) =>
      item.baseCurrency?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.quoteCurrency?.toLowerCase().includes(searchTerm.toLowerCase()) ||
      item.pair?.toLowerCase().includes(searchTerm.toLowerCase())
  );

  useEffect(() => {
    try {
      fetchCurrencyPairRates(
        selectedCurrencyPair?.baseCurrency,
        selectedCurrencyPair?.quoteCurrency
      );
    } catch (error) {
      console.log(error);
    }
  }, [selectedCurrencyPair]);


  const handleRateChange = (e, rowId) => {
    try {
      const { name, value } = e.target;

      // console.log(`name ${name} and value ${value}`);
      const updatedData = [...currencyPairRates];
      const rowIndex = updatedData.findIndex(item => item._id === rowId);

      if (rowIndex === -1) {
        console.log('Row not found');
      }

      updatedData[rowIndex][name] = value;
      updatedData[rowIndex]["changed_xx"] = "Y";

      setCurrencyPairRates(updatedData);
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteRate") {
        const res = await newRequest.delete(`/glCurrencyRate/del/${objectToAction.object_id}`);
        fetchCurrencyPairRates(
          selectedCurrencyPair?.baseCurrency,
          selectedCurrencyPair?.quoteCurrency
        );
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };



  const saveRecord = async (e) => {
    // e.preventDefault();
    try {

      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 5000));


      const changedRates = currencyPairRates.filter(
        (obj) => obj.changed_xx === "Y"
      );

      // console.log(`changedRates  ${JSON.stringify(changedRates, null, 2)}`);

      for (let i = 0; i < changedRates.length; i++) {
        const res = await newRequest.put(
          `/glCurrencyRate/upd/${changedRates[i]._id}`,
          {
            rate: changedRates[i].rate,
            rate_date_fm: changedRates[i].rate_date_fm,
            rate_date_to: changedRates[i].rate_date_to
          }
        );
      }
      showToast("Saved!", "success");
    } catch (err) {
      console.log(err);
    } finally {


    }
  };

  return (
    <div className="gl-currency">
      {isLoading ? (
        <div className="no-content">
          <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="gl-currency-main-wrapper">
          <div className="gl-currency-center-wrapper">
            <div className="gl-currency-center-details">
              <div className="gl-currency-center-navbar">
                <div className="navbar-left">
                  <h1 className="main-title">{`CONVERSION FROM ${selectedCurrencyPair?.baseCurrency} TO ${selectedCurrencyPair?.quoteCurrency}`}</h1>
                </div>
                <div className="navbar-right">
                  <span
                    className="selected-type"
                    style={{ width: "max-content" }}
                  >
                    {selectedCurrencyPair?.pair}
                  </span>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#00D37F"
                    tooltip="Save changes"
                    endIcon={<FaSave />}
                    onClick={saveRecord}
                  >
                    {t('save')}
                  </CustomLoadingButton>
                  <CustomLoadingButton
                    currentTheme={currentTheme}
                    iconPosition="end"
                    borderRadiusType="both"
                    variant="tint"
                    color="#0ea5a4"
                    tooltip={`ADD EXCHANGE RATE FROM ${selectedCurrencyPair?.baseCurrency} TO ${selectedCurrencyPair?.quoteCurrency}`}
                    endIcon={<MdAdd />}
                    onClick={() => {
                      try {
                        setCurrencyAction("addRate");
                        setIsNewRateDialogOpened(true);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                  >
                    {t('addRate')}
                  </CustomLoadingButton>
                  {/* This part shows if the menu was opened from home screen */}
                  {showBack === "Y" &&
                    <span className="back-icon" onClick={() => navigate(-1)}>
                      <MdArrowBackIos size={24} />
                    </span>}
                </div>
              </div>
              <div className="table-content">
                <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }}
                  className="table-container">
                  <Table sx={{ width: "max-content", border: 'none' }}>
                    <TableHead className="tablehead">
                      <TableRow className="tablerow">
                        <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                          #
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('from').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                          <span>{t('to').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                          <span />
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "170px" }}>
                          <span>{t('periodFrom').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell center" style={{ maxWidth: "170px" }}>
                          <span>{t('periodTo').toUpperCase()}</span>
                        </TableCell>
                        <TableCell className="table-cell right" style={{ width: "auto" }}>
                          <span>{t('rate').toUpperCase()}</span>
                        </TableCell>
                        {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            <span>{t('action').toUpperCase()}</span>
                          </TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody className="tablebody">
                      {slicedCurrencyPairRates?.map((row, index) => (
                        <TableRow
                          key={row._id}
                          className={`${selectedCurrencyPairRate?._id === row._id ? "tablerow current" : "tablerow"}`}
                          onClick={() => setSelectedCurrencyPairRate(row)}
                        >
                          <TableCell className="table-cell center" style={{ maxWidth: "50px" }}>
                            {currentPage * rowsPerPage + index + 1}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            {row.rate_cur_code_fm}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                            {row.rate_cur_code_to}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "40px" }}>
                            {row.rate_md}
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "170px" }}>
                            <div className="input-item-with-label">
                              <input
                                id="rate_date_fm"
                                name="rate_date_fm"
                                type="date"
                                value={moment(row.rate_date_fm).format("YYYY-MM-DD")}
                                onChange={(e) => handleRateChange(e, row._id)}
                                style={{ width: "100%" }}
                                className="form-input-item table"
                              />
                            </div>
                          </TableCell>
                          <TableCell className="table-cell center" style={{ maxWidth: "170px" }}>
                            <div className="input-item-with-label">
                              <input
                                id="rate_date_to"
                                name="rate_date_to"
                                type="date"
                                value={moment(row.rate_date_to).format("YYYY-MM-DD")}
                                onChange={(e) => handleRateChange(e, row._id)}
                                style={{ width: "100%" }}
                                className="form-input-item table"
                              />
                            </div>
                          </TableCell>
                          <TableCell className="table-cell right" style={{ width: "auto" }}>
                            <div className="input-item-with-label">
                              <input
                                id="rate"
                                name="rate"
                                type="number"
                                value={row.rate}
                                onChange={(e) => handleRateChange(e, row._id)}
                                style={{ width: "100%", textAlign: "right" }}
                                className="form-input-item table"
                              />
                            </div>
                          </TableCell>
                          {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
                            <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                              <CircularButton
                                currentTheme={currentTheme}
                                color="#E53935"
                                tooltip={`Remove rate ${row.rate}?`}
                                onClick={() => {
                                  try {
                                    setObjectToAction({
                                      object_id: row._id,
                                      action_text: `Remove rate ${row.rate}?`,
                                      new_doc_status: "deleteRate",
                                    });
                                    setConfirmDialogAction("deleteRate");
                                    setIsConfirmDialogOpen(true);
                                  } catch (error) {
                                    console.log(error);
                                  }
                                }}
                                icon={<MdDelete />}
                                width={"30px"} height={"30px"} />
                            </TableCell>}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                  {currencyPairRates?.length > rowsPerPage &&
                    <TablePagination
                      rowsPerPageOptions={[12]}
                      rowsPerPage={rowsPerPage}
                      onRowsPerPageChange={handleRowsPerPage}
                      component="div"
                      count={currencyPairRates?.length}
                      rows={currencyPairRates}
                      page={currentPage}
                      onPageChange={handlePageChange}
                    />}
                </TableContainer>
              </div>
            </div>
          </div>
          <div className="gl-currency-right-wrapper">
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "center", gap: "5px", width: "100%" }}>
              {/* Search */}
              <div className="homeSearch">
                <FiSearch className="homeSearchIcon" />
                <input
                  className="homeSearchInput"
                  type="text"
                  placeholder={t('search')}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                // onKeyDown={(e) => {
                //   if (e.key === "Enter") handleSearchUsers();
                // }}
                />
                {searchTerm?.length > 0 ? (
                  <MdClose
                    className="homeSearchClear"
                    onClick={() => setSearchTerm("")}
                  />
                ) : (
                  <span className="homeSearchClearPlaceholder" />
                )}
              </div>
            </div>
            {["admin", "superadmin"].includes(currentUser.user_type_xx) &&
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#0ea5a4"
                tooltip={"Add new transaction currency"}
                endIcon={<MdAdd />}
                onClick={() => {
                  try {
                    setCurrencyAction("addCurrency");
                    setIsNewRateDialogOpened(true);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                width={"100%"}
              >
                {t('addCurrency')}
              </CustomLoadingButton>}
            <div className="options-list">
              {filteredCurrencyPairs?.map((row) => (
                <div key={row._id}
                  className={`${selectedCurrencyPair._id === row._id
                    ? "single-option active"
                    : "single-option"
                    }`}
                  onClick={() => setSelectedCurrencyPair(row)}
                >
                  <div className="title-row">
                    <span className="cy-title">{row?.pair}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={
          <div dangerouslySetInnerHTML={{ __html: objectToAction.action_text }} />
        }
      />
      {isNewRateDialogOpened && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <span className="main-title">{`${currencyAction === "addRate" ? t('addRate').toUpperCase() : t('addCurrency').toUpperCase()}`}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setNewRateFmDate(null);
                    setNewRateToDate(null);
                    setNewRate(null);

                    setNewCurrencyCode(null);
                    setNewCurrencyName(null);
                    setNewCurrencySymbol(null);

                    setIsNewRateDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              {/* fields for rate */}
              {currencyAction === "addRate" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newRateFmDate"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('from').toUpperCase()}
                    </label>
                    <input
                      id="newRateFmDate"
                      name="newRateFmDate"
                      type="date"
                      placeholder={t('from').toUpperCase()}
                      value={newRateFmDate}
                      className="form-input-item"
                      style={{ width: "170px" }}
                      onChange={handleFmDateChange}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newRateToDate"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('to').toUpperCase()}
                    </label>
                    <input
                      id="newRateToDate"
                      name="newRateToDate"
                      type="date"
                      placeholder={t('to').toUpperCase()}
                      value={newRateToDate}
                      className="form-input-item"
                      style={{ width: "170px" }}
                      onChange={handleToDateChange}
                    />
                  </div>

                  <div className="input-item-with-label">
                    <label
                      htmlFor="newRate"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('rate').toUpperCase()}
                    </label>
                    <input
                      id="newRate"
                      name="newRate"
                      type="number"
                      placeholder="0.00"
                      value={newRate}
                      className="form-input-item"
                      style={{ width: "170px", textAlign: "right" }}
                      onChange={(e) => setNewRate(e.target.value)}
                    />
                  </div>
                </div>
              )}
              {/* field for currency */}
              {currencyAction === "addCurrency" && (
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "5px",
                  }}
                >
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newCurrencyName"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('name').toUpperCase()}
                    </label>
                    <input
                      id="newCurrencyName"
                      name="newCurrencyName"
                      type="text"
                      placeholder={t('name').toUpperCase()}
                      value={newRate}
                      className="form-input-item"
                      style={{ width: "250px" }}
                      onChange={(e) => setNewCurrencyName(e.target.value)}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newCurrencyCode"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('code').toUpperCase()}
                    </label>
                    <input
                      id="newCurrencyCode"
                      name="newCurrencyCode"
                      type="text"
                      placeholder={t('code').toUpperCase()}
                      value={newRate}
                      className="form-input-item"
                      style={{ width: "150px" }}
                      onChange={(e) => {
                        try {
                          setNewCurrencyCode(e.target.value);
                          setNewCurrencySymbol(e.target.value);
                        } catch (error) {
                          console.log(error);
                        }
                      }}
                    />
                  </div>
                  <div className="input-item-with-label">
                    <label
                      htmlFor="newCurrencySymbol"
                      className="form-dropdown-label"
                      style={{ width: "130px" }}
                    >
                      {t('symbol').toUpperCase()}
                    </label>
                    <input
                      id="newCurrencySymbol"
                      name="newCurrencySymbol"
                      type="text"
                      placeholder={t('symbol').toUpperCase()}
                      value={newRate}
                      className="form-input-item"
                      style={{ width: "150px" }}
                      onChange={(e) => setNewCurrencySymbol(e.target.value)}
                    />
                  </div>
                </div>
              )}
            </div>
            <div className="overlay-actions">
              {currencyAction === "addRate" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  onClick={handleAddRate}>
                  {t('add').toUpperCase()}
                </CustomLoadingButton>
              )}
              {currencyAction === "addCurrency" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  onClick={handleAddCurrency}>
                  {t('add').toUpperCase()}
                </CustomLoadingButton>
              )}
            </div>
          </div>
        </motion.div>
      )}
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default GlCurrency;
